import React, { useState } from "react";
import { Lock, Unlock, Loader2 } from "lucide-react";
import { toast } from "sonner";

const STORAGE = "raceHandicap.colsUnlocked.v1";
export const OWNER_PW_KEY = "raceHandicap.ownerPw";
const mono = { fontFamily: "'JetBrains Mono', ui-monospace, monospace" };

export const useHiddenCols = () => {
  const [unlocked, setUnlocked] = useState(() => localStorage.getItem(STORAGE) === "1");
  const set = (v) => {
    if (v) localStorage.setItem(STORAGE, "1");
    else {
      localStorage.removeItem(STORAGE);
      localStorage.removeItem(OWNER_PW_KEY);
    }
    setUnlocked(v);
  };
  return [unlocked, set];
};

export const HiddenColsLock = ({ unlocked, onChange }) => {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!pw) return;
    setBusy(true);
    try {
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/unlock-columns`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: pw }),
      });
      if (!r.ok) throw new Error("Wrong password");
      localStorage.setItem(OWNER_PW_KEY, pw);
      onChange(true);
      setPw("");
      toast.success("Hidden columns unlocked on this browser");
    } catch (err) {
      toast.error(err.message || "Unlock failed");
    } finally {
      setBusy(false);
    }
  };

  if (unlocked) {
    return (
      <button
        type="button"
        onClick={() => onChange(false)}
        data-testid="hidden-cols-lock-btn"
        className="inline-flex items-center gap-1.5 h-7 px-2.5 rounded border border-stone-700 text-[10px] uppercase tracking-[0.18em] font-bold text-[#a3e635] hover:border-[#84cc16] transition-colors"
        style={mono}
        title="Hide DD, DDPO, SLLWP, SLPO and rank columns again"
      >
        <Unlock size={12} /> Lock
      </button>
    );
  }
  return (
    <form onSubmit={submit} className="inline-flex items-center gap-1.5" data-testid="hidden-cols-form">
      <Lock size={12} className="text-stone-500" />
      <input
        type="password"
        value={pw}
        onChange={(e) => setPw(e.target.value)}
        placeholder="Password"
        autoComplete="current-password"
        data-testid="hidden-cols-password"
        className="h-7 w-28 px-2 rounded bg-[#0a0a0a] border border-stone-700 text-[11px] text-stone-200 placeholder:text-stone-600 focus:outline-none focus:border-[#84cc16]"
        style={mono}
      />
      <button
        type="submit"
        disabled={busy || !pw}
        data-testid="hidden-cols-unlock-btn"
        className="h-7 px-2 rounded border border-stone-700 text-[10px] uppercase tracking-[0.16em] font-bold text-stone-300 hover:border-[#84cc16] hover:text-[#a3e635] disabled:opacity-40 transition-colors"
        style={mono}
      >
        {busy ? <Loader2 size={12} className="animate-spin" /> : "Open"}
      </button>
    </form>
  );
};
